export default "__VITE_ASSET__BIaQk8QQ__"